

































import { Cookie } from '@/contract/cookies.contract';
import { analyticsEventService } from '@/services/analytics/analytics-event.service';
import { AnalyticsEventCategory, AnalyticsEventName } from '@/services/analytics/analytics.contract';
import { interfaceLanguages } from '@/shared/i18n/i18n';
import { Component, Vue } from 'vue-property-decorator';
import MobileMenuEntry from '@/components/general/mobileMenu/MobileMenuEntry.vue';

@Component({
  components: {
    MobileMenuEntry,
  },
})
export default class LanguageSelector extends Vue {
  public get languages(): string[] {
    return interfaceLanguages;
  }

  public get currentLanguage(): string {
    return this.$root.$i18n.locale;
  }

  public async selectLanguage(lang: string): Promise<void> {
    if (lang === this.currentLanguage) {
      return;
    }
    /*  Set the language in the cookie and then reload the page. So data that comes from the back-end is also reloaded
     *  Note that this could also be done by emitting an application wide language changed event which could trigger
     *  data reloads. This is the easier fix.
     */
    this.$cookies.set(Cookie.Language, lang, Infinity);
    analyticsEventService.trackEvent(AnalyticsEventName.LanguageChange, AnalyticsEventCategory.Interface, lang);
    this.$router.go(0);
  }
}
